import {
    appChooseAndUpImage,
    appWeiXinPay,
    openUrl,
    appCallPhone
} from "@/utils/native";
import {
    chooseAndUpImage
} from "@/utils/wx";
import store from '@/store/index'
import {
    secretKey,
    appSecretKey
} from "@/api/wx";

// 选择并上传图片
export function cuImage(params) {
    return store.state.isApp ? appChooseAndUpImage() : chooseAndUpImage(params)
}


// 微信支付
export function wxPay(params) {
    return new Promise((resolve) => {
        if (!store.state.isApp) {
            // 微信支付
            secretKey(params).then(res => {
                const data = res.data;
                WeixinJSBridge.invoke(
                    "getBrandWCPayRequest", {
                        appId: data.appId, // 公众号名称,由商户传入
                        timeStamp: data.timeStamp, // 时间戳,自1970年以来的秒数
                        nonceStr: data.nonceStr, // 随机串
                        package: data.package1,
                        signType: data.signType, // 微信签名方式：
                        paySign: data.paySign // 微信签名
                    },
                    function(res) {
                        if (
                            res.err_msg ==
                            "get_brand_wcpay_request:ok"
                        ) {
                            resolve();
                        }
                    }
                );
            });
        } else {
            // app 微信支付
            appSecretKey(params).then(res => {
                const data = res.data;
                appWeiXinPay({
                    // 应用id
                    appid: data.appid,
                    // 商户号
                    partnerid: data.partnerid,
                    // 预支付交易会话id
                    prepayid: data.prepayid,
                    // 扩展字段
                    package: data.package_,
                    // 随机串
                    noncestr: data.noncestr,
                    // 时间戳
                    timestamp: data.timestamp,
                    // 签名
                    sign: data.sign
                }).then(res => {
                    if (res) {
                        resolve();
                    }
                });
            });
        }
    })
}
// 调整链接
export function openLink(url) {
    if (url) {
        // 如果是同域名链接，直接跳转
        if (store.state.isApp && url.indexOf(window.location.origin) < 0) {
            openUrl(url);
        } else {
            window.location.href = url;
        }
    }
}
// 拨打电话、安卓环境需调用原生方法
export function callTel(tel) {
    if (tel) {
        if (store.state.isApp) {
            const u = navigator.userAgent,
                // 判断ios或安卓环境
                isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1;
            if (isAndroid) {
                appCallPhone(tel);
            } else {
                window.location.href = `tel:${tel}`;
            }
        } else {
            window.location.href = `tel:${tel}`;
        }
    }
}